import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// web/src/components/chat/templates/NewsBrief.tsx
// News-style layout for herald-led intents ("what's the news", "what's
// happening with rates"). Headlines + brief commentary + optional macro
// chart. No recommendations, no action cards.
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Renderer } from "../../../rendering";
export function NewsBrief({ message }) {
    const text = message.content?.trim() ?? "";
    // Charts come from inline_renders if the orchestrator surfaced macro
    // visuals; fall back to specialist[0].renders for backward compat.
    const charts = (message.inline_renders && message.inline_renders.length > 0)
        ? message.inline_renders
        : (message.specialists?.[0]?.renders ?? []);
    return (_jsxs("div", { className: "space-y-2", children: [text && (_jsx("div", { className: "text-sm text-slate-200 leading-relaxed", children: _jsx(ReactMarkdown, { remarkPlugins: [remarkGfm], children: text }) })), charts.length > 0 && (_jsx("div", { className: "space-y-2 mt-2", children: charts.map((b, i) => (_jsx(Renderer, { block: b }, i))) }))] }));
}
